import Service from "../../service/index";


const Injury = {
    namespaced: true,
    state: {
        injury_type: [],
        injury_area: [],
    },
    mutations: {
        GET_INJURYTYPE: (state, data) => {
            state.injury_type = data;
        },
        GET_INJURYAREA: (state, data) => {
            state.injury_area = data;
        },

    },
    actions: {
        setInjurytype({commit}){
            return Service.Injury.getInjurytype()
                .then(data=>{
                    commit("GET_INJURYTYPE",data);
                })
        },
        setInjuryarea({commit}){
            return Service.Injury.getInjuryarea()
                .then(data=>{
                    commit("GET_INJURYAREA",data);
                })
        },
    }
};
export default Injury;
